module.exports = __webpack_public_path__ + "static/media/dimsum.fa9dd077.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dimsum.svg
// module id = 76
// module chunks = 0